// frontend/src/shared/theme/radius.js

const radius = {
  sm: 12,
  md: 16,
  lg: 18,
  xl: 22,
  "2xl": 24,
  pill: 999,
};

export default radius;